import axios from '@/extensions/axios'

const actions = {
  get ({ commit }) {
    return axios.get('roles')
      .then(({ data }) => {
        commit('SET', data)
      })
  },

  getByName ({ commit }, name) {
    return axios.get('roles/' + name)
      .then(({ data }) => {
        commit('SET_NEW', data)
      })
  },

  create ({ state }) {
    return axios.post('roles', {
      name: state.newRole.newName,
      description: state.newRole.description
    })
  },

  save ({ state }) {
    return axios.put('roles/' + state.newRole.name, {
      name: state.newRole.newName,
      description: state.newRole.description
    })
  },

  getPermissions ({ commit, state }) {
    return axios.get('roles/' + state.newRole.name + '/permissions')
      .then(({ data }) => {
        commit('SET_ASSIGNED_PERMISSIONS', data)
        commit('SET_PERMISSIONS', data)
      })
  },

  savePermissions ({ state, commit }) {
    const assigned = state.assignedPermissions.map(permission => permission.name)
    const selected = state.selectedPermissions.map(permission => permission.name)
    const promises = []
    assigned.forEach(permission => {
      if (!selected.includes(permission)) {
        promises.push(
          axios.delete('roles/' + state.newRole.name + '/child/' + permission)
        )
      }
    })
    selected.forEach(permission => {
      if (!assigned.includes(permission)) {
        promises.push(
          axios.post('roles/' + state.newRole.name + '/child', {
            child: permission
          })
        )
      }
    })
    return Promise.all(promises).then(() => {
      commit('SET_ASSIGNED_PERMISSIONS', state.selectedPermissions)
    })
  },

  remove ({ state }) {
    return axios.delete('roles/' + state.newRole.name)
  }
}

export default actions
